module.exports = __webpack_public_path__ + "images/login-header.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/login/login-header.png
// module id = 344
// module chunks = 0